import React from 'react';

function SectionLabel({ number, label }) {
  return (
    <div className="section-label" aria-hidden="true">
      <span>{number}</span>
      <i />
      <span>{label}</span>
    </div>
  );
}

export default SectionLabel;